import { render, staticRenderFns } from "./stopSetting.vue?vue&type=template&id=2b61282c&scoped=true"
import script from "./stopSetting.vue?vue&type=script&lang=js"
export * from "./stopSetting.vue?vue&type=script&lang=js"
import style0 from "./stopSetting.vue?vue&type=style&index=0&id=2b61282c&prod&lang=less&scoped=true"
import style1 from "./stopSetting.vue?vue&type=style&index=1&id=2b61282c&prod&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2b61282c",
  null
  
)

export default component.exports